import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "slider-field",

  data() {
    return {
      sliderValues: [],
      origin: [0, 5000000000],
      inputed: [120000, 400000]
    };
  },

  props: ["originValues", "userValues"],

  mounted: function() {
    if (this.originValues) {
      this.origin = this.originValues;
    }

    if (this.userValues == undefined) {
      this.sliderValues = this.originValues;
    }
  },

  watch: {
    originValues: function(newValues) {
      this.origin = newValues;
    },

    userValues: function(newV) {
      this.sliderValues = newV;
    }
  },

  methods: {
    changeValues() {
      this.$emit("updateSliderRange", this.sliderValues);
    }
  },

  components: {
    VueSlider
  }
};
